import dayjs from 'dayjs';
import React from 'react';
import { TDateFormat, getDateFormat } from '@apia/util';
import {
  TResponsiveTableCellRenderer,
  TResponsiveTableCellRendererProps,
} from '../types';

export function getStatusRendererClassName(
  cellValue: string,
  columnName: string,
) {
  if (cellValue === undefined) return '';

  const cellValueDate = cellValue.split(' ')[0];
  const cellValueHour = cellValue.split(' ')[1] ?? '00:00:00';

  const dateFormat: TDateFormat = getDateFormat();
  const currentDate = dayjs();
  const currentHour = Number(dayjs().format('HHmm'));
  const queriedDate = dayjs(cellValueDate, dateFormat);
  const queriedHour = Number(dayjs(cellValueHour, dateFormat));
  let statusClassName = '';

  if (currentDate >= queriedDate) {
    statusClassName = columnName;
  }
  if (!queriedHour) return statusClassName;

  if (currentDate <= queriedDate && currentHour < queriedHour) {
    statusClassName = columnName;
  }
  return statusClassName;
}

const NoMemoStatusRenderer: TResponsiveTableCellRenderer<{ src: string }> =
  React.forwardRef<
    HTMLTableCellElement,
    TResponsiveTableCellRendererProps<{ src: string }>
  >(
    (
      {
        cell: { children, Renderer, rendererProps, AccordionRenderer, ...cell },
        column,
        row,
        ...props
      },
      currentRef,
    ) => {
      const taskStatusClassName = getStatusRendererClassName(
        children as string,
        column.name,
      );

      return (
        <td
          {...props}
          {...cell}
          ref={currentRef}
          className={taskStatusClassName}
        >
          {children}
        </td>
      );
    },
  );

NoMemoStatusRenderer.displayName = 'StatusRenderer';

export const StatusRenderer = NoMemoStatusRenderer;
